import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=69e797e8&scoped=true&"
import script from "./Datenschutz.vue?vue&type=script&lang=ts&"
export * from "./Datenschutz.vue?vue&type=script&lang=ts&"
import style0 from "./Datenschutz.vue?vue&type=style&index=0&id=69e797e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e797e8",
  null
  
)

export default component.exports